import { ANSWER_MESSAGE, FrameWorkGetMapFromItem, FrameWorkGetPrimaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkSimpleMessageState, OrdenExpressGetCurrentUser, OrdenExpressIsAdmin, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork.js';
import { setDataDeliveryPointForEdit, setDataUserForEdit, setMessageSaveState } from 'orden_express/users/usersActions.js';
import { requestGetUsers, responseGetUsers } from 'orden_express/users/usersEpic.js';
import React from 'react';
import { connect } from 'react-redux';
import { Badge, Button, Card, CardBody, CardFooter, CardText, Col, FormGroup, Input, Row, UncontrolledTooltip } from 'reactstrap';
import { bindActionCreators } from 'redux';


class Users extends React.Component {

  getInicialstate() {
    return {
      filterText: '',
      alert: ''
    };
  }

  constructor(props) {
    super(props);
    this.state = this.getInicialstate();
    OrdenExpressValidateSecurity(this);
  }

  componentDidMount = () => {
    this.startRequestUsersToDB();
  }

  /**
   * Se ejecuta cuando ya etsando la opción desplegada
   * se da nuevamente click en el menú.
   */
  reloadPage() {
    this.setState(this.getInicialstate());
    OrdenExpressValidateSecurity(this);
    this.startRequestUsersToDB();
  }

  componentDidUpdate = (prevProps) => {

    if (prevProps.location.key !== this.props.location.key) {
      this.reloadPage();
    }
    if (this.props.userReducerState.messageSaveState !== prevProps.userReducerState.messageSaveState) {
      this.processMessageState(this.props.userReducerState.messageSaveState);
    }
  }

  startRequestUsersToDB = () => {
    if (OrdenExpressIsAdmin(this)) {
      this.props.setMessageSaveState(1);
      this.props.requestGetUsers();
    } else {
      responseGetUsers(ANSWER_MESSAGE(false, 'datos del usuario actual', '', [OrdenExpressGetCurrentUser(this)]));
      //responseGetUsers(OrdenExpressValidateSecurityForAnswer(response))
    }
  }

  sendToEditDeliveryPoint = (pUser, pDeliveryPoint = null) => {
    this.props.setDataUserForEdit(pUser);
    this.props.setDataDeliveryPointForEdit(pDeliveryPoint);
    //this.props.history.push('/admin/usersDeliveryPoints');
    OrdenExpressNavegatePath(this, 'usersDeliveryPoints');
  }

  sendToEditUser = (pUser) => {
    this.props.setDataUserForEdit(pUser);
    //this.props.history.push('/admin/usersForm');
    OrdenExpressNavegatePath(this, 'usersForm');
  }

  /**
  * Controla la secuencia de estados para visualizar 
  * los mensajes en el proceso 
  */
  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Mostrando usuarios', 'Su solicitud está en proceso ...');
        break;
      case 2:
        FrameWorkHideAlert(this);
        this.props.setMessageSaveState(0);
        break;
      case 3:
        var localMessageError = this.props.userReducerState.responseGetUsers;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageSaveState(0);
        break;
    }
  }

  renderFilters = () => {
    return (
      <FormGroup >
        <Input
          className='ml-1 mt-2 mr-0'
          type='text'
          placeholder='Buscar'
          id='idfilterText'
          value={this.state.filterText}
          onChange={(newtext) => { this.setState({ filterText: newtext.target.value }) }}
        />
      </FormGroup>
    )
  }

  applyFilters = (pContent) => {
    try {
      var filter = this.state.filterText.toUpperCase();
      var result = [];
      var localText = '';
      var pos = 0;
      var length = pContent.length;
      while (pos < length) {
        var item = pContent[pos];
        var deliveryPoints = item.deliveryPoints || [];
        localText = '';
        var posDelivery = 0;
        var lengthDelivery = deliveryPoints.length;
        while (posDelivery < lengthDelivery) {
          var localDeliveryPoint = deliveryPoints[posDelivery];
          localText +=
            (
              localDeliveryPoint.name + ' ' +
              localDeliveryPoint.cityName + ' ' +
              localDeliveryPoint.address + ' ' +
              localDeliveryPoint.information + ' ' +
              localDeliveryPoint.longitude + ' ' +
              localDeliveryPoint.latitude + ' '
            );
          posDelivery++;
        }
        /*deliveryPoints.map((localDeliveryPoint) => {
          localText +=
            (
              localDeliveryPoint.name + ' ' +
              localDeliveryPoint.cityName + ' ' +
              localDeliveryPoint.address + ' ' +
              localDeliveryPoint.information + ' ' +
              localDeliveryPoint.longitude + ' ' +
              localDeliveryPoint.latitude + ' '
            );
        });*/
        localText +=
          (
            item.name + ' ' +
            item.profile + ' ' +
            item.typeIdentification + ' ' +
            item.identification + ' ' +
            item.phone + ' ' +
            item.email + ' '
          );
        localText = localText.toUpperCase();
        var activeUser = (item.active === 1 || item.active === true ? 'ACTIVO' : 'INACTIVO');
        var addToShow = false;
        if (filter === 'ACTIVO' || filter === 'INACTIVO') {
          addToShow = activeUser === filter;
        } else {
          addToShow = (localText.includes(filter) || activeUser.includes(filter))
        }
        if (addToShow) {
          result.push(item);
        }
        pos++;
      }
    } catch (__) {
      return pContent;
    }
    return result;
  }

  render = () => {
    var listOfUsers = [];
    try {
      listOfUsers = this.applyFilters(this.props.userReducerState.responseGetUsers.result || []);
    } catch (__) { }
    return (
      <div className='content mt-5 mb-0'>
        {this.state.alert}
        <div className='framework-flexcontainer'>
          <div>
            <h4>{'Usuarios'}</h4>
          </div>
          <div className='text-right framework-flex-rigth'>
            <Button
              color={FrameWorkGetPrimaryColorButton()}
              className='btn-round mb-1 ml-6'
              onClick={() => { this.sendToEditUser(null) }}
            >
              <i className='icon-big nc-icon nc-single-02 text-white' />
              {'+ usuario'}
            </Button>
            <br />
          </div>
        </div>
        <Card className='mb-1'>
          <CardBody>
            <Row className='framework-v-center'>
              <Col xs='auto'>
                <b>Filtros</b>
              </Col>
              <Col>
                {this.renderFilters()}
              </Col>
            </Row>
          </CardBody>
        </Card>
        {
          listOfUsers.map((item, index) => {
            return (
              <Card
                className={`mb-1 mt-0 ${index % 2 === 0 ? 'bg-gray' : 'bg-white'}`}
                key={`cardUser${index}`}
              >
                <CardBody className='mb-0   '
                  key={`CardBodyUser${index}`}
                >
                  <div className='framework-flexcontainer'>
                    <b>
                      {item.name}
                    </b>
                    <div className='framework-flex-rigth'>
                      <Badge style={{ width: 80 }} color={item.active === 1 || item.active === true ? 'success' : 'danger'} pill>
                        {item.active === 1 || item.active === true ? 'Activo' : 'Inactivo'}
                      </Badge>
                    </div>
                  </div>
                  <CardText className='mb-1'
                    key={`CardTextBodyUser${index}`}
                  >{
                      item.profile + ' ' +
                      item.typeIdentification + ':' +
                      item.identification + ' ' +
                      item.phone + ' ' + item.email}</CardText>
                  <b>Puntos de entrega</b>
                  {
                    FrameWorkGetMapFromItem(item, 'deliveryPoints').map((localDeliveryPoint, indexDelivery) => {
                      return (
                        <div key={`cardUserPoint${index}deliveryPoint${indexDelivery}`}>
                          <Row className='mt-0'>
                            <Col md='1' className='mr-2' >
                              <Button
                                className='btn-icon btn-round mt-0'
                                color={FrameWorkGetPrimaryColorButton()}
                                id={`editDeliveryPointUser${index}-${indexDelivery}`}
                                type='button'
                                outline
                                size='md'
                                onClick={value => {
                                  var localuserToEdit = item;
                                  this.sendToEditDeliveryPoint(localuserToEdit, localDeliveryPoint);
                                }}
                              >
                                <i className='fa fa-pencil' />
                              </Button>
                              <UncontrolledTooltip
                                delay={0}
                                target={`editDeliveryPointUser${index}-${indexDelivery}`}
                              >
                                Editar punto de entrega
                                </UncontrolledTooltip>
                            </Col>
                            <Col className='align-middle'>
                              <CardText>
                                <Badge className='mr-2' style={{ width: 80 }} color={localDeliveryPoint.active === 1 || localDeliveryPoint.active === true ? 'success' : 'danger'} pill>
                                  {localDeliveryPoint.active === 1 || localDeliveryPoint.active === true ? 'Activo' : 'Inactivo'}
                                </Badge>
                                {localDeliveryPoint.name}
                                <br />
                                {
                                  localDeliveryPoint.cityName + ' ' + localDeliveryPoint.address + ' ' + localDeliveryPoint.information
                                  + ' ' + localDeliveryPoint.longitude + ' ' + localDeliveryPoint.latitude
                                }
                              </CardText>
                            </Col>
                          </Row>
                          <hr />
                        </div>
                      )
                    })
                  }
                </CardBody>
                <CardFooter className='text-right mt-0 mb-0 pt-0 pb-0'>
                  <FormGroup check className='mt-0'>
                    <Button
                      className='btn-icon btn-round mt-0 mr-2'
                      color={FrameWorkGetPrimaryColorButton()}
                      id={`plusDeliveryPointUser${index}`}
                      type='button'
                      outline
                      size='lg'
                      onClick={value => {
                        var localuserToEdit = item;
                        this.sendToEditDeliveryPoint(localuserToEdit);
                      }}
                    >
                      <i className='fa fa-map-marker' />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      target={`plusDeliveryPointUser${index}`}
                    >
                      Agregar punto de entrega
                      </UncontrolledTooltip>

                    <Button
                      className='btn-icon btn-round mt-0'
                      color={FrameWorkGetPrimaryColorButton()}
                      id={`editUser${index}`}
                      type='button'
                      outline
                      size='lg'
                      onClick={value => {
                        var localuserToEdit = item;
                        this.sendToEditUser(localuserToEdit);
                      }}
                    >
                      <i className='fa fa-pencil' />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      target={`editUser${index}`}
                    >
                      Editar usuario
                      </UncontrolledTooltip>
                  </FormGroup>
                </CardFooter>
              </Card>
            )

          })
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userReducerState: state.userReducerState,
    loginReducerState: state.loginReducerState
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setDataDeliveryPointForEdit: dataDeliveryPointForEdit => dispatch(setDataDeliveryPointForEdit(dataDeliveryPointForEdit)),
    requestGetUsers: () => bindActionCreators(dispatch(requestGetUsers()), dispatch),
    setDataUserForEdit: (dataUserForEdit) => dispatch(setDataUserForEdit(dataUserForEdit)),
    setMessageSaveState: messageSaveState => dispatch(setMessageSaveState(messageSaveState)),
    responseGetUsers: dataUsers => dispatch(responseGetUsers(dataUsers)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);